// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"eb3b0a2b","37":"deede6d9","51":"07d0c328","83":"32525876","279":"7af41827","310":"39720158","426":"fa385565","514":"161ff97b","529":"4a2471a3","621":"61f4f7a6","651":"bac03ba7","791":"462147b8"}[chunkId] + ".chunk.js";
};